import { Checkbox, MenuItem, TextField } from "@mui/material";
import { PropValueLine } from "../../common/PropValueLine";
import { WorldRenderer } from "../../WorldRenderer";
import { useEffect, useState } from "react";
import { RobotVisual } from "../../../visuals/RobotVisual";
import { createRobot, Robot } from "../../../models/Robot";
import { loadOrgRecords } from "../../../api/connection";

export function RobotProps({ wr, robot, onUpdate }: {
  wr: WorldRenderer,
  robot: RobotVisual,
  onUpdate: (robot: Partial<RobotVisual>) => void
}) {
  const [robots, setRobots] = useState<Robot[]>([]);
  useEffect(() => {
    (async () => {
      const rs = await loadOrgRecords("robots", createRobot);
      setRobots(rs);
    })();
  }, [wr]);
  if (robots.length === 0) return null;
  return (
    <>
      <PropValueLine label='Robot ID' value={
        <TextField
          fullWidth
          select
          value={robot.robotId}
          variant="standard"
          size="small"
          onChange={(e) => {
            onUpdate({ robotId: e.target.value });
          }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {robots.map((r) => (
            <MenuItem key={r._id} value={r._id}>
              {r.name}
            </MenuItem>
          ))}
        </TextField>
      } />
      <PropValueLine label='Sensors' value={
        <Checkbox
          checked={robot.visualizeSensors}
          onChange={(e, checked) => {
            onUpdate({ visualizeSensors: checked });
          }}
        />
      } />
    </>
  );
} 